<div class="visually-hidden route-announcer" aria-live="polite" aria-atomic="true">{{ routeAnnouncerService.announcement }}</div>
<ng-container [ngTemplateOutlet]="loadedTemplate" />
<ng-template #defaultTemplate>
  <a class="d-flex align-items-center justify-content-center position-absolute cursor-pointer skip-to-content-link"
     tabindex="0"
     (click)="skipToContent()"
     (keydown)="skipToContent($event)">
    Skip to main content
  </a>
  <div class="bs-loading-container">
    <div id="container">
      <header class="d-flex align-items-center d-print-none" id="header" role="banner">
        <sas-menu-button />
        <header-content />
      </header>
      <div class="container-fluid wrapper" id="wrapper">
        <sas-menu />
        <section #content class="content" id="content-view" tabindex="-1">
          <sas-toolbar />
          <router-outlet />
        </section>
      </div>
      <footer></footer>
    </div>
  </div>
  <sas-spinner />
</ng-template>

<ng-template #embeddedTemplate>
  <div class="bs-loading-container">
    <div id="container">
      <div class="container-fluid wrapper" id="wrapper">
        <section class="content embedded" id="content-view">
          <back-button class="d-print-none" custom-state-back="stateBack" />
          <router-outlet />
        </section>
      </div>
    </div>
  </div>
  <sas-spinner />
</ng-template>
